import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './AdminSidebar.css';

function AdminSidebar({ isVisible = true }) {
  const { currentUser, logout } = useAuth();
  const location = useLocation();
  
  const isActive = (path) => {
    if (path === '/admin' && location.pathname === '/admin') {
      return true;
    }
    if (path === '/statistics' && location.pathname === '/statistics') {
      return true;
    }
    return false;
  };

  return (
    <div className={`admin-sidebar ${isVisible ? 'visible' : 'hidden'}`}>
      <div className="sidebar-header">
        <h3>NSTP Admin</h3>
        <div className="admin-info">
          <div className="admin-avatar">
            {currentUser?.email.charAt(0).toUpperCase()}
          </div>
          <div className="admin-details">
            <p className="admin-name">{currentUser?.email.split('@')[0]}</p>
            <p className="admin-role">Administrator</p>
          </div>
        </div>
      </div>
      
      <div className="sidebar-menu">
        <Link to="/admin" className={`menu-item ${isActive('/admin') ? 'active' : ''}`}>
          <i className="menu-icon bi bi-speedometer2"></i>
          <span>Students Management</span>
        </Link>
        
        <Link to="/statistics" className={`menu-item ${isActive('/statistics') ? 'active' : ''}`}>
          <i className="menu-icon bi bi-bar-chart"></i>
          <span>Dashboard & Statistics</span>
        </Link>
        
        <Link to="/admin?tab=announcements" className={`menu-item ${location.pathname === '/admin' && location.search.includes('tab=announcements') ? 'active' : ''}`}>
          <i className="menu-icon bi bi-megaphone"></i>
          <span>Announcements</span>
        </Link>
        
        <Link to="/admin?tab=slideshow" className={`menu-item ${location.pathname === '/admin' && location.search.includes('tab=slideshow') ? 'active' : ''}`}>
          <i className="menu-icon bi bi-image"></i>
          <span>Slideshow Manager</span>
        </Link>
        
        <Link to="/admin?tab=orgchart" className={`menu-item ${location.pathname === '/admin' && location.search.includes('tab=orgchart') ? 'active' : ''}`}>
          <i className="menu-icon bi bi-diagram-3"></i>
          <span>Organizational Chart</span>
        </Link>
        
        <Link to="/admin?tab=emailtest" className={`menu-item ${location.pathname === '/admin' && location.search.includes('tab=emailtest') ? 'active' : ''}`}>
          <i className="menu-icon bi bi-envelope"></i>
          <span>Email System</span>
        </Link>
      </div>
      
      <div className="sidebar-footer">
        <Link to="/" className="menu-item">
          <i className="menu-icon bi bi-house-door"></i>
          <span>Home</span>
        </Link>
        
        <button onClick={logout} className="menu-item logout-btn">
          <i className="menu-icon bi bi-box-arrow-right"></i>
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
}

export default AdminSidebar; 